import {styled, Typography} from "@mui/material";
import EqualIcon from "assets/icons/EqualIcon";
import SqueredPlusIcon from "assets/icons/SqueredPlusIcon";
import {currencyFormat} from "./Blocks";

const SummaryComponentContainer = styled("div")(({theme}) => ({
    height: "120px",
    backgroundColor: "#F0F2F8",
    width: "100%",
    borderRadius: "4px",
    marginBottom: "32px",
    display: "grid",
    gridTemplateColumns: "27% 9.5% 27% 9.5% 27%",
}));
const SummaryItem = styled("div")(({theme}) => ({
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "24px 0",
}));
const SummarySign = styled("div")(({theme}) => ({
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
}));

const SummaryComponent = ({
                              data: {assetsSum, debtsSum, salariesSum},
                          }: {
    data: { assetsSum: number; debtsSum: number; salariesSum: number };
}) => {
    return (
        <SummaryComponentContainer>
            <SummaryItem>
                <Typography color="text.secondary">بدهی ها</Typography>
                {currencyFormat(debtsSum)}
            </SummaryItem>
            <SummarySign>
                <SqueredPlusIcon/>
            </SummarySign>
            <SummaryItem>
                <Typography color="text.secondary">حقوق صاحبان سهام</Typography>
                {currencyFormat(salariesSum)}
            </SummaryItem>
            <SummarySign>
                <EqualIcon/>
            </SummarySign>
            <SummaryItem>
                <Typography color="text.secondary">دارایی ها</Typography>
                {currencyFormat(assetsSum)}
            </SummaryItem>
        </SummaryComponentContainer>
    );
};

export default SummaryComponent;
